import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import Header from '../components/Header';
import Appfooter from '../components/Appfooter';
import { Spinner } from 'react-bootstrap';
import LeftMenu from '../components/LeftMenu';

import i18n from '../utils/i18n';
import { getPlansByCreatorId, savePlan } from '../services/creator';
import { creator, isCreator } from '../signals/creator';
import { Modal } from 'react-bootstrap';
import Button from '../components/Button';

const validationSchema = Yup.object().shape({
  monthlySubscription: Yup.string()
    .required('Campo obrigatório')
    .test('min-value', 'O valor mínimo é de R$ 19,90', function(value) {
      if (!value) return false;
      const numericValue = parseFloat(value.replace(/\./g, '').replace(',', '.'));
      return numericValue >= 19.90;
    }),
});

type FormValues = {
  instagramAccount: string;
  xAccount: string;
  tiktokAccount: string;
  site: string;
  monthlySubscription: string;
};

const CreatorSettings = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [plan, setPlan] = useState<Plan>();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showBankAccountConfirmationModal, setShowBankAccountConfirmationModal] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  useEffect(() => {
    if (!isCreator.value) {
      navigate('/');
      return;
    }
  }, [navigate]);

  useEffect(() => {
    const loadPlan = async () => {
      try {
        setLoading(true);
        if (isCreator.value && creator.value) {
          const plans = await getPlansByCreatorId(creator.value.id);

          if (plans.length) {
            setPlan(plans[0]);
          }
        }
      } catch (error) {
        console.log('Error on load plan');
      } finally {
        setLoading(false);
      }
    };

    loadPlan();
  }, []);

  const onSubmit = async (values: FormValues) => {
    try {
      setLoading(true);

      // Remove separadores de milhares (pontos) e substitui vírgula por ponto
      const formattedValue = values.monthlySubscription
        .replace(/\./g, '') // Remove pontos (separador de milhares)
        .replace(',', '.'); // Substitui vírgula por ponto (separador decimal)

      const valueInCents = Math.round(parseFloat(formattedValue) * 100); // Convert to float and multiply by 100

      await savePlan(valueInCents);

      setShowBankAccountConfirmationModal(true);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const {
    handleSubmit,
    setFieldValue,
    isValid,
    values,
    errors,
    setFieldError,
  } = useFormik({
    initialValues: {
      instagramAccount: '',
      xAccount: '',
      tiktokAccount: '',
      site: '',
      monthlySubscription: '19,90',
    },
    validationSchema,
    onSubmit,
    validateOnBlur: false,
  });

  return (
    <>
      <Header />
      <LeftMenu />
      <div className="main-content right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="middle-wrap">
              <div className="card w-100 border-0 bg-white shadow-xs p-0" style={{ marginBottom: '100px' }}>
                {loading ? (
                  <div
                    style={{
                      height: 500,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Spinner
                      animation="border"
                      role="status"
                      className="text-warning mt-3"
                    />
                  </div>
                ) : (
                  <>
                    <div className="card-body p-4 w-100 border-0 d-flex rounded-3">
                      <button
                        onClick={() => navigate(-1)}
                        className="d-inline-block mt-2 bg-transparent border-0"
                      >
                        <i className="ti-arrow-left font-sm text-black"></i>
                      </button>
                      <h4 className="font-xs text-black fw-600 ms-4 mb-0 mt-2">
                        {i18n.t<string>('CreatorSettings.title')}
                      </h4>
                    </div>
                    <div className="card-body p-lg-5 p-4 w-100 border-0 ">
                      <form>
                        <div className="row mb-5">
                          <div className="form-group">
                            {!plan && (
                              <div className="alert alert-warning d-flex align-items-start mb-4" style={{
                                backgroundColor: '#fff8e1',
                                border: '1px solid #ffeeba',
                                borderRadius: '8px',
                                padding: '16px'
                              }}>
                                <i className="feather-alert-triangle text-warning me-3 mt-1" style={{ fontSize: '20px' }}></i>
                                <div className="flex-grow-1">
                                  <p className="font-xsss fw-600 mb-0 text-dark">
                                    <span className="text-warning">Atenção:</span> Para realizar a alteração do valor do plano, será necessário entrar em contato com o nosso suporte em:{' '}
                                    <span className="text-warning">help@silksecret.me</span>
                                  </p>
                                </div>
                              </div>
                            )}
                            <div className="d-flex flex-row justify-content-center">
                              <label className="mont-font fw-600 font-xss mb-4 me-2">
                                {i18n.t<string>(
                                  'CreatorSettings.monthlySubscription'
                                )}
                              </label>
                            </div>
                            <div className="d-flex flex-row justify-content-center">
                              <label className="mont-font fw-600 font-xs me-2">
                                R$
                              </label>
                              <div className="d-flex flex-column">
                                <input
                                  name="monthlySubscription"
                                  type="text"
                                  className="form-control"
                                  value={
                                    plan
                                      ? (plan.value / 100).toLocaleString('pt-BR', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2
                                        })
                                      : values.monthlySubscription
                                  }
                                  placeholder="19,90"
                                  autoFocus
                                  disabled={plan ? true : false}
                                  onChange={(e) => {
                                    const input = e.target.value;
                                    // Remove tudo que não é número
                                    const numbers = input.replace(/\D/g, '');
                                    
                                    if (!numbers) {
                                      setFieldValue('monthlySubscription', '');
                                      setFieldError('monthlySubscription', '');
                                      return;
                                    }
                                    
                                    // Converte para centavos (divide por 100)
                                    const cents = parseInt(numbers, 10);
                                    const reais = cents / 100;
                                    
                                    // Formata no padrão brasileiro
                                    const formatted = reais.toLocaleString('pt-BR', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    });
                                    
                                    setFieldValue('monthlySubscription', formatted);
                                    
                                    // Valida em tempo real se o valor é menor que 19.90
                                    if (reais < 19.90) {
                                      setFieldError('monthlySubscription', 'O valor mínimo é de R$ 19,90');
                                    } else {
                                      setFieldError('monthlySubscription', '');
                                    }
                                  }}
                                  style={{
                                    fontSize: 20,
                                    padding: '8px 12px',
                                    fontWeight: 700,
                                    color: '#495057',
                                    textAlign: 'center',
                                    border: '2px solid #e9ecef',
                                    borderRadius: '8px',
                                    backgroundColor: plan ? '#f8f9fa' : '#ffffff',
                                    outline: 'none',
                                    transition: 'all 0.2s ease-in-out',
                                  }}
                                  onFocus={(e) => {
                                    if (!plan) {
                                      e.target.style.borderColor = '#FF4B6E';
                                      e.target.style.boxShadow = '0 0 0 3px rgba(255, 75, 110, 0.1)';
                                    }
                                  }}
                                  onBlur={(e) => {
                                    e.target.style.borderColor = '#e9ecef';
                                    e.target.style.boxShadow = 'none';
                                  }}
                                />
                                <span className="text-danger font-xsss fw-500 mt-2 text-center">
                                  {errors.monthlySubscription
                                    ? errors.monthlySubscription
                                    : ''}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        {!plan ? (
                          <div>
                            <div className="d-flex justify-content-center mb-4">
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  id="acceptTerms"
                                  className="form-check-input"
                                  checked={acceptedTerms}
                                  onChange={(e) => setAcceptedTerms(e.target.checked)}
                                  style={{ cursor: 'pointer' }}
                                />
                                <label 
                                  htmlFor="acceptTerms" 
                                  className="form-check-label font-xsss text-grey-700" 
                                  style={{ cursor: 'pointer', userSelect: 'none' }}
                                >
                                  Eu li e aceito que o valor inserido só poderá ser alterado através do suporte em{' '}
                                  <span className="text-warning fw-600">help@silksecret.me</span>
                                </label>
                              </div>
                            </div>
                            <div className="d-flex justify-content-center align-items-center">
                              <Button
                                onClick={() => {
                                  const formattedValue =
                                    values.monthlySubscription.replace(
                                      ',',
                                      '.'
                                    );

                                  if (Number(formattedValue) < 19.90) {
                                    setFieldError(
                                      'monthlySubscription',
                                      'O valor mínimo é de R$ 19,90'
                                    );
                                    return;
                                  }
                                  setShowConfirmationModal(true);
                                }}
                                disabled={!isValid || !acceptedTerms}
                                type="button"
                                className="bg-warning border-0 text-center text-white font-xsss fw-600 w175 rounded-3"
                                style={
                                  !isValid || !acceptedTerms ? { opacity: 0.5 } : { opacity: 1 }
                                }
                              >
                                Salvar Plano
                              </Button>
                            </div>
                          </div>
                        ) : (
                          <p className="font-xsss fw-600 mt-2">
                            Para realizar a alteração do valor do plano, entre
                            em contato com o nosso suporte em:{' '}
                            <span className="text-warning">
                              help@silksecret.me
                            </span>
                          </p>
                        )}
                      </form>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showConfirmationModal}>
        <Modal.Header
          closeButton
          onClick={() => setShowConfirmationModal(false)}
          className="bg-white"
          style={{
            border: 0,
            borderRadius: 0,
            padding: 20,
            borderTopLeftRadius: 10,
            WebkitBorderTopRightRadius: 10,
          }}
        />
        <Modal.Body className="bg-white">
          <p className="font-xs text-black text-center">
            Deseja realmente confirmar o plano de{' '}
            <span className="fw-600 font-md">{`R$ ${values.monthlySubscription}`}</span>{' '}
            por mês ?
          </p>
          <p className="font-xsss fw-600 mt-2">
            Para realizar a alteração do valor do plano, será necessário entrar
            em contato com o nosso suporte em:{' '}
            <span className="text-warning">help@silksecret.me</span>
          </p>
        </Modal.Body>
        <Modal.Footer className="bg-white d-flex flex-row">
          <div className="form-group mb-1 flex-grow-1">
            <button
              onClick={() => setShowConfirmationModal(false)}
              className="form-control text-center text-white fw-600 bg-dark border-0 p-0"
            >
              Não
            </button>
          </div>
          <div className="form-group mb-1 flex-grow-1">
            <Button
              onClick={() => {
                setShowConfirmationModal(false);
                handleSubmit();
              }}
            >
              Confirmar
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={showBankAccountConfirmationModal}>
        <Modal.Header
          closeButton
          onClick={() => setShowBankAccountConfirmationModal(false)}
          className="bg-white"
          style={{
            border: 0,
            borderRadius: 0,
            padding: 20,
            borderTopLeftRadius: 10,
            WebkitBorderTopRightRadius: 10,
          }}
        />
        <Modal.Body className="bg-white">
          <p className="font-xs text-black text-center">
            Deseja cadastrar ou alterar seus dados bancários?
          </p>
        </Modal.Body>
        <Modal.Footer className="bg-white d-flex flex-row">
          <div className="form-group mb-1 flex-grow-1">
            <button
              onClick={() => {
                setShowBankAccountConfirmationModal(false);
                window.location.reload();
              }}
              className="form-control text-center text-white fw-600 bg-dark border-0 p-0"
            >
              Não
            </button>
          </div>
          <div className="form-group mb-1 flex-grow-1">
            <Button
              onClick={() => {
                navigate('/payout-account');
              }}
            >
              Sim
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Appfooter />
    </>
  );
};

export default CreatorSettings;
